import {HTMLAttributes, MouseEventHandler} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';

interface BelowTabTextButtonProps extends HTMLAttributes<HTMLSpanElement> {
  onClick?: MouseEventHandler;
}

export function BelowTabTextButton({
  children,
  onClick,
  className,
  ...props
}: BelowTabTextButtonProps) {
  return (
    <Text
      className={twMerge(
        'font-small2 cursor-pointer select-none text-ellipsis break-all text-theme-solid-100 line-clamp-1',
        className
      )}
      onClick={onClick}
      {...props}
    >
      {children}
    </Text>
  );
}

export const BelowTabTextButtonType = (<BelowTabTextButton />).type;
